var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{attrs:{"id":"app"}},[(_vm.header_is_visible)?_c('div',{staticClass:"header_wrapper"},[_c('Header')],1):_vm._e(),_c('div',[_c('router-view')],1),_c('Help')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }